/**
 * Life4Earth V2 — Chronicle "Current Status" updates API adapter
 * (DEV-1352 — Topic Tracker now-state).
 *
 * Dated TipTap narrative + photos stream; the latest is pinned at the top of
 * the About tab. Mirrors projectStatusReports.ts but chronicle-scoped, and omits
 * the Journal/feed posting fields (syndication is a deferred fast-follow).
 */

import { apiFetch } from './client';

export interface ChronicleStatusPhoto {
  photoGuid: string;
  storageKey: string;
  caption?: string | null;
  position: number;
}

export interface ChronicleStatusUpdate {
  statusUpdateGuid: string;
  chronicleGuid: string;
  reportingDate: string;
  narrativeHtml: string;
  postedByUserGuid: string;
  postedAt: string;
  photos: ChronicleStatusPhoto[];
}

export interface ChronicleStatusUpdateSummary {
  statusUpdateGuid: string;
  reportingDate: string;
  postedByUserGuid: string;
  postedAt: string;
}

export interface ChronicleStatusPhotoItem {
  storageKey: string;
  caption?: string | null;
  position: number;
}

export interface CreateChronicleStatusUpdateBody {
  reportingDate: string;
  narrativeHtml: string;
  photos?: ChronicleStatusPhotoItem[];
}

export interface UpdateChronicleStatusUpdateBody {
  narrativeHtml: string;
  photos?: ChronicleStatusPhotoItem[];
}

export const listChronicleStatusUpdates = (chronicleGuid: string) =>
  apiFetch<ChronicleStatusUpdateSummary[]>(`/api/chronicles/${chronicleGuid}/status-updates`);

export const getLatestChronicleStatusUpdate = (chronicleGuid: string) =>
  apiFetch<ChronicleStatusUpdate>(`/api/chronicles/${chronicleGuid}/status-updates/latest`);

export const getChronicleStatusUpdate = (chronicleGuid: string, guid: string) =>
  apiFetch<ChronicleStatusUpdate>(`/api/chronicles/${chronicleGuid}/status-updates/${guid}`);

export const createChronicleStatusUpdate = (
  chronicleGuid: string,
  body: CreateChronicleStatusUpdateBody,
) =>
  apiFetch<ChronicleStatusUpdate>(`/api/chronicles/${chronicleGuid}/status-updates`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const updateChronicleStatusUpdate = (
  chronicleGuid: string,
  guid: string,
  body: UpdateChronicleStatusUpdateBody,
) =>
  apiFetch<ChronicleStatusUpdate>(`/api/chronicles/${chronicleGuid}/status-updates/${guid}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });

export const deleteChronicleStatusUpdate = (chronicleGuid: string, guid: string) =>
  apiFetch<void>(`/api/chronicles/${chronicleGuid}/status-updates/${guid}`, { method: 'DELETE' });
